//utils
import { validation } from 'utils/validation';

const isContentValid = content => {
    if(!content) return true;
    switch (content.contentType) {
        case 'quiz':
            if (!content.questionBased.correctOptionSelected) return false;
            // fall through
        case 'poll':
            if (!content.questionBased.isTitleValid) return false;
            for (let contentId of Object.keys(content.questionBased.options)) {
                if (!content['questionBased']['options'][contentId]['isValid'] ||
                    content['questionBased']['options'][contentId]['isValid'] instanceof Object) return false;
            }
            if (['image1', 'text1', 'text2'].includes(content.questionBased.type)) return optionsValid(content.questionBased.options);
            return true;
        case 'story':
            return (!!content.story.isTitleValid && !!content.story.isURLValid) && (!!content.story.isCTAValid && !!content.story.isCTAValid);
        default:
            return true;
    }
};

const optionsValid = (options) => {
   let optionTexts = [];
   for (let contentId of Object.keys(options)) {
        optionTexts.push(options[contentId]['text']);
   }
   const duplicateRemovedOptionTexts = [... new Set(optionTexts)];
   return duplicateRemovedOptionTexts.length === optionTexts.length;
};

// const allContentsValid = contents => {
//     // console.log(contents)
//     for (let content of Object.values(contents)) {
//         if (!!!content.queuePosition) { continue; } // skip inactive content validation
//         if(!isContentValid(content)) { return false; }
//     }
//     return true;
// };

const isAddOnValid = (type, data) => {
    switch (type) {
        case 'EMAIL_COLLECTION':
            return isEmailCollectionValid(data);
        default:
            return true;
    }
};

const isEmailCollectionValid = data => !!data.body.value && !!data.headline.value && !!data.publisherName.value && !!validation.storyURL.test.test(data.publisherPrivacyPolicyURL.value);


export { isContentValid, isAddOnValid };
